<template>
	<v-data-iterator
		:items="items ? items : cachedItems"
		:items-per-page="itemsPerPage"
		:return-object="true"
		:loading="loading"
		:data-test="`${dataTest}-dataiterator`"
	>
		<template #header="headerProps">
			<slot name="card-header" v-bind="headerProps"></slot>
		</template>
		<template #loader>
			<Loading></Loading>
		</template>
		<template #default="defaultProps">
			<slot
				name="card-item"
				v-bind="{
					...defaultProps,
					filterSave,
					dataTest: `${dataTest}-dataiterator`,
				}"
			></slot>
		</template>
		<template #no-data>
			<v-container fluid>
				<v-row>
					<v-col :cols="12">
						<v-row align="center" justify="center">
							<NoData
								:error="error"
								:loading="loading"
								:name="`${dataTest}-dataiterator`"
							></NoData>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</template>
		<template #footer>
			<DataTableFooter
				:page="page"
				:items-per-page="itemsPerPage"
				:items-length="itemCount"
				:items-per-page-options="paginate.rows"
				@update:page="handlePageChange"
				@update:items-per-page="emit('update:items-per-page', $event)"
			></DataTableFooter>
		</template>
	</v-data-iterator>
</template>

<script setup lang="ts">
import Loading from '@/components/templates/Loading.vue'
import NoData from 'templates/Datatable/NoData.vue'
import type { DataTablePaginate } from '@/types/table.ts'
import DataTableFooter from 'templates/Datatable/DataTableFooter.vue'
import { useI18n } from 'vue-i18n'

type CardPresenationProps = {
	cachedItems?: any[]
	items: any[]
	loading?: boolean
	itemCount?: number
	page?: number
	itemsPerPage?: number
	paginate?: DataTablePaginate
	error?: any
	name?: string
	dataTest: string
}

withDefaults(defineProps<CardPresenationProps>(), {
	cachedItems: undefined,
	loading: false,
	itemCount: 0,
	page: 1,
	itemsPerPage: 25,
	error: null,
	paginate: undefined,
	name: '',
})

const emit = defineEmits([
	'update:page',
	'filter-save',
	'update:items-per-page',
])
const { t } = useI18n()

// Methods
function handlePageChange(newPage: number) {
	emit('update:page', newPage)
}

// Pass through the filterSave event
function filterSave(value: any) {
	emit('filter-save', value)
}
</script>
